import React, { useState } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import { Link } from 'react-router-dom';
import ArrowLeftIcon from '../../components/icons/ArrowLeftIcon';
import image1 from '../../assets/img/capacitacion/cap-1.png';
import image2 from '../../assets/img/capacitacion/cap-2.png';
import image3 from '../../assets/img/capacitacion/cap-3.png';
import image4 from '../../assets/img/capacitacion/cap-4.png';
import image5 from '../../assets/img/capacitacion/cap-5.png';

const VideoGalleryScreen = () => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);

    const openLightbox = (video) => {
        setCurrentVideo(video);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
        setCurrentVideo(null);
    };

    // Sample video data - in a real app, this would come from an API
    const videos = [
        {
            id: 1,
            module: "Modulo 1",
            title: "Turismo Accesible",
            estimatedTime: "24 min",
            imageUrl: image1, // Placeholder image URL
            youtubeUrl: "https://www.youtube.com/watch?v=TZCfydWF48c"
        },
        {
            id: 2,
            module: "Modulo 2",
            title: "Diseño de Experiencia",
            estimatedTime: "24 min",
            imageUrl: image2,
            youtubeUrl: "https://www.youtube.com/watch?v=TZCfydWF48c"
        },
        {
            id: 3,
            module: "Modulo 3",
            title: "Diseño de Instalaciones",
            estimatedTime: "24 min",
            imageUrl: image3,
            youtubeUrl: "https://www.youtube.com/watch?v=TZCfydWF48c"
        },
        {
            id: 4,
            module: "Modulo 4",
            title: "Servicios",
            estimatedTime: "24 min",
            imageUrl: image4,
            youtubeUrl: "https://www.youtube.com/watch?v=TZCfydWF48c"
        },
        {
            id: 5,
            module: "Modulo 5",
            title: "¿Cómo puedo crecer?",
            estimatedTime: "24 min",
            imageUrl: image5,
            youtubeUrl: "https://www.youtube.com/watch?v=TZCfydWF48c"
        },
    ];

    return (
        <DashboardLayout activeMenuItem="Capacitación" userRole="supplier" isScrollable>
            <div className="container-fluid py-4">
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-5">
                            <div className="d-flex align-items-center">
                                <Link to="/home" className="btn btn-back-circle me-3" title="Volver a servicios">
                                    <ArrowLeftIcon />
                                </Link>
                                <h2 className="mb-0">Capacitación: Sello Checkin</h2>
                            </div>
                        </div>
                        <div className="row">
                            {videos.map((video) => (
                                <div key={video.id} className="col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-4">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <img
                                            src={video.imageUrl}
                                            className="card-img-top"
                                            alt={video.title}
                                            style={{ height: '400px', objectFit: 'cover' }}
                                        />
                                        <div className="card-body d-flex flex-column my-4">
                                            <div className="mb-2">
                                                <span className="small">{video.module}</span>
                                            </div>
                                            <h5 className="card-title mb-3">{video.title}</h5>
                                            <div className="mb-3 d-flex align-items-center text-muted">
                                                <i className="bi bi-camera-video me-2"></i>
                                                <small>Tiempo estimado: {video.estimatedTime}</small>
                                            </div>
                                            <div className="mt-auto">
                                                <button
                                                    onClick={() => openLightbox(video)}
                                                    className="btn btn-outline-checkin"
                                                >
                                                    Ver video
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Lightbox Modal */}
            {lightboxOpen && currentVideo && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        zIndex: 1055
                    }}
                    onClick={closeLightbox}
                >
                    <div
                        className="bg-white rounded position-relative"
                        style={{
                            width: '90%',
                            maxWidth: '800px',
                            maxHeight: '80vh',
                            overflow: 'hidden'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={closeLightbox}
                            className="btn btn-light position-absolute"
                            style={{
                                top: '10px',
                                right: '10px',
                                zIndex: 10,
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <i className="bi bi-x-lg"></i>
                        </button>

                        {/* Video Title */}
                        <div className="p-3 border-bottom">
                            <h5 className="mb-0">{currentVideo.title}</h5>
                            <small className="text-muted">{currentVideo.module}</small>
                        </div>

                        {/* Video Content */}
                        <div className="p-3">
                            <div className="ratio ratio-16x9">
                                <iframe
                                    src={currentVideo.youtubeUrl.replace('youtube.com/watch?v=', 'youtube.com/embed/') + '?autoplay=1'}
                                    title={currentVideo.title}
                                    allowFullScreen
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </DashboardLayout>
    );
};

export default VideoGalleryScreen;